import Marquee from "react-fast-marquee";
import { PARTNERS } from "../../data";
import { Reveal } from "./Reveal";

export const Partners = () => (
  <section id="partner" className="relative py-20 sm:py-28 bg-[#f2ece4]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4 text-center">
          Partner Kami
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2c1e16] text-center max-w-3xl mx-auto leading-tight">
          Dipercaya hotel-hotel ternama di Yogyakarta.
        </h2>
        <p className="mt-4 text-center text-[#5c4033] max-w-xl mx-auto">
          Kami rutin melayani tamu di berbagai hotel &amp; penginapan terbaik
          se-Jogja.
        </p>
      </Reveal>
    </div>

    <div className="mt-14">
      <Marquee speed={45} gradient gradientColor="#f2ece4" gradientWidth={80} pauseOnHover autoFill>
        {PARTNERS.map((p, i) => (
          <div
            key={`${p.name}-${i}`}
            data-testid={`partner-${i}`}
            className="mx-4 flex items-center justify-center h-32 w-56 rounded-2xl bg-white border border-[#e5d9c5] shadow-[0_8px_24px_rgba(92,64,51,0.06)]"
            title={p.name}
          >
            <img
              src={p.logo}
              alt={`${p.name} - partner Javanese Spa Jogja`}
              className="max-h-24 max-w-[80%] object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </Marquee>
    </div>
  </section>
);
